import React, { useEffect, useState } from "react";
import { routes } from "../../api/routes";
import { callApi } from "../../api/apiCaller";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/loader/loader";

const Terms = () => {
  const [isloading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [terms, setTerms] = useState([]);
  const [getServiceapi, setGetServiceApi] = useState(false);

  const getTerms = () => {
    const getRes = (res) => {
      console.log("res of getTerms", res);
      const aboutUsContent = res?.data?.data?.[0]?.data || "";
      setTerms(aboutUsContent);
    };

    callApi("GET", routes.getTerms, null, setIsLoading, getRes, (error) => {
      console.log("error", error);
    });
  };

  useEffect(() => {
    getTerms();
  }, [getServiceapi]);

  return (
    <div>
      <Loader loading={isloading} />
      <div
        style={{ marginLeft: "5rem", marginTop: "5rem", fontSize: ".8rem" }}
        dangerouslySetInnerHTML={{ __html: terms }}
      />
    </div>
  );
};

export default Terms;
